import { useTranslation } from 'next-i18next'
import { CountryCode } from '@hublo/enums'

export interface Country {
  countryCode: CountryCode
  name: string
  flag: string
}

export const useSortedCountries = (): Country[] => {
  const { t } = useTranslation('common.countries')

  const countries: Country[] = [
    {
      countryCode: CountryCode.FR,
      name: t('france'),
      flag: '🇫🇷',
    },
    {
      countryCode: CountryCode.DE,
      name: t('germany'),
      flag: '🇩🇪',
    },
    {
      countryCode: CountryCode.BE,
      name: t('belgium'),
      flag: '🇧🇪',
    },
    {
      countryCode: CountryCode.LU,
      name: t('luxemburg'),
      flag: '🇱🇺',
    },
    {
      countryCode: CountryCode.ES,
      name: t('spain'),
      flag: '🇪🇸',
    },
    {
      countryCode: CountryCode.CH,
      name: t('switzerland'),
      flag: '🇨🇭',
    },
    {
      countryCode: CountryCode.RE,
      name: t('reunion'),
      flag: '🇫🇷',
    },
    {
      countryCode: CountryCode.GP,
      name: t('guadeloupe'),
      flag: '🇬🇵',
    },
    {
      countryCode: CountryCode.GF,
      name: t('giuana'),
      flag: '🇬🇫',
    },
    {
      countryCode: CountryCode.MQ,
      name: t('martinique'),
      flag: '🇲🇶',
    },
    {
      countryCode: CountryCode.NC,
      name: t('new_caledonia'),
      flag: '🇳🇨',
    },
    {
      countryCode: CountryCode.PF,
      name: t('polynesia'),
      flag: '🇵🇫',
    },
    {
      countryCode: CountryCode.PM,
      name: t('stpierre'),
      flag: '🇵🇲',
    },
    {
      countryCode: CountryCode.WF,
      name: t('wallis_and_futuna'),
      flag: '🇼🇫',
    },
    {
      countryCode: CountryCode.MC,
      name: t('monaco'),
      flag: '🇲🇨',
    },
  ]

  return countries.sort((left, right) => left.name.localeCompare(right.name))
}
